namespace GeniuzPOS.ReportMasterData {
    export interface Report1332Data extends Serenity.ListRequest {
        Details?: Report1332ShopPaymentTypeRefTypeRow[];
        ShopName?: string;
        FillterString?: string;
        username?: string;
        Printdate?: string;
    }
}
